import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import Logo from "@/assets/icons/logo-blue.png";

export const Route = createFileRoute("/_public")({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <div className="w-full bg-muted flex min-h-svh flex-col items-center py-6 px-1 md:px-10">
      <Link to="/auth/login">
        <img src={Logo} alt="Logo" className="max-h-8 mb-6" />
      </Link>
      <Outlet />
    </div>
  );
}
